import { render } from "./Part.vue?vue&type=template&id=1609c15f"
import script from "./Part.vue?vue&type=script&lang=js"
export * from "./Part.vue?vue&type=script&lang=js"
script.render = render

export default script